import React from 'react';
import cn from 'classnames';

import { getTranslation } from 'helpers/getTranslation';

import { WrongIcon } from 'components/WrongIcon';
import { CompletedIcon } from 'components/CompletedIcon';
import { Typography } from 'components/shared/Typography';

import { PreviewPlaceholder } from 'components/PreviewPlaceholder';

import styles from './AnswerImage.module.scss';

const AnswerImage = ({
  submitted,
  correct,
  checked,
  answersMultiple,
  data,
  comment,
  previewType,
  isTestMode,
  onClick,
}: {
  submitted: any;
  correct: any;
  checked: any;
  answersMultiple: any;
  data: any;
  comment: any;
  previewType: any;
  isTestMode: any;
  onClick: any;
}) => (
  <div
    className={cn(styles.answer, {
      [styles.pluginImage]:
        previewType === getTranslation('common.text.plugin'),
      [styles.readOnlyAnswer]: !isTestMode,
      [styles.answerSelected]: checked,
      [styles.answerCorrect]:
        (checked && correct && submitted) || (!checked && correct && submitted),
      [styles.answerIncorrect]: checked && !correct && submitted,
      [styles.answerSubmitted]: submitted,
      [styles.answerWithComment]:
        ((checked && correct && submitted) ||
          (!checked && correct && submitted) ||
          (checked && !correct && submitted)) &&
        comment,
    })}
    onClick={!submitted ? onClick : () => {}}
  >
    {data ? (
      <img className={styles.img} src={data} />
    ) : (
      <PreviewPlaceholder variant="quiz" />
    )}
    <CompletedIcon
      className={cn(styles.iconWrapper, styles.iconWrapperCorrect)}
      iconClassName={styles.icon}
    />
    <WrongIcon
      className={cn(styles.iconWrapper, styles.iconWrapperIncorrect)}
      iconClassName={styles.icon}
    />
    {comment &&
      ((checked && correct && submitted) ||
        (!checked && correct && submitted) ||
        (checked && !correct && submitted)) && (
        <Typography
          className={cn(styles.comment, {
            [styles.commentCorrect]:
              (checked && correct && submitted) ||
              (!checked && correct && submitted),
            [styles.commentIncorrect]: checked && !correct && submitted,
          })}
          variant="body2"
          mode="compact"
        >
          {comment}
        </Typography>
      )}
  </div>
);

export default React.memo(AnswerImage) as any;
